import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";

function TimePickOrderSadan(props) {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  return (<>
    <div className="div__group__input_select mx-2">
      <label className="form-check-label"  >
        ساعت پرداخت
      </label>
      <input
        dir="rtl"
        id={"rnd2"}
        className={"w-100"}
        type={"time"}
        onChange={(e) => {
          setData({paymentTime: e.target.value})
        }}
        value={data.paymentTime}
        className="form-control newinput"
        step="1"
      />
    </div>
  </>);
}

export default TimePickOrderSadan;